import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const Breadcrumb = ({ items = [] }) => (
  <nav aria-label="breadcrumb" className="text-sm text-slate-500">
    <ol className="flex items-center gap-2 flex-wrap">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <li key={item.to || item.label} className="flex items-center gap-2">
            {!isLast && item.to ? (
              <Link to={item.to} className="hover:text-[#12964A]">{item.label}</Link>
            ) : (
              <span className="text-[#1F2937] font-medium">{item.label}</span>
            )}
            {!isLast && <ChevronRight className="w-3.5 h-3.5 text-slate-300" />}
          </li>
        );
      })}
    </ol>
  </nav>
);

export default Breadcrumb;
